export default {"src":"/_next/static/media/image 8.84334c2f.svg","height":81,"width":81,"blurWidth":0,"blurHeight":0};